import React from 'react';

import { useRecordContext } from 'components/record/useRecordContext';
import List from 'components/list/List';
import { ListField } from 'components/list/Fields';
import { CheckCircleOutline, Draw, RemoveCircleOutline } from '@mui/icons-material';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ActionMenuItemDelete from 'components/list/actionMenu/ActionMenuItemDelete';
import ActionMenuItemUpdate from 'components/list/actionMenu/ActionMenuItemUpdate';
import EntriesFilters from './EntriesFilters';
import ButtonDialog from 'components/forms/ButtonDialog';
import EntriesEmail from './Email/EntriesEmail';
import BulkUpdate from 'components/forms/BulkUpdate';
import { Box } from '@mui/material';
import BulkDelete from 'components/forms/BulkDelete';

const Entries = ({ filters = {} }: { filters?: { slug?: string } }) => {
  const { record: event } = useRecordContext();

  return (
    <List
      bulkOptions
      hidePagination
      title="Entries"
      listFilters={<EntriesFilters />}
      avatar={<Draw />}
      refresh
      toolbar={
        <React.Fragment>
          <ButtonDialog buttonLabel="Import e-mails" dialogTitle="Emails">
            <EntriesEmail event={event} />
          </ButtonDialog>
        </React.Fragment>
      }
      bulkActions={
        <Box gap={2} display="flex">
          <BulkUpdate data={{ status: 'accept' }} label="Accept" icon={<CheckCircleOutline />} />
          <BulkUpdate data={{ status: 'reject' }} label="Reject" icon={<RemoveCircleOutline />} />
          <BulkDelete />
        </Box>
      }
      filters={filters}
    >
      <ListField source="userName" label="User Name" />
      {/* <DateField source="createdAt" label="Date" /> TODO: */}
      <ListField source="subEvent.event.name" label="Event" />
      <ListField source="subEvent.name" label="Sub Event" />
      <ListField source="status" label="Status" />
      <ActionMenu label="Actions" align="right" width="5%" variant="cell">
        <ActionMenuItemUpdate label="Accept" icon={<CheckCircleOutline />} data={{ status: 'accept' }} />
        <ActionMenuItemUpdate label="Reject" icon={<RemoveCircleOutline />} data={{ status: 'reject' }} />
        <ActionMenuItemDelete />
      </ActionMenu>
    </List>
  );
};

export default Entries;
